/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import React from 'react';
import { useRouteMatch, Switch, useHistory, Route, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Persist } from 'formik-persist';
import {
  getMobileCovidRoutes,
  getMobileCovidFromYesAnswerRoutes,
} from '../../../routes/mobile/speak-doctor/covidRoutes';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import PregnantNavBtn from '../../../components/mobile/speak-doctor/PregnantNavBtn';
// import useLocation from '../../../containers/hooks/useLocation';
// import useUUID from '../../../containers/hooks/useUUID';
import { errorNotification } from '../../../utils/notification-helpers';
import { postScreeningAPICall } from '../../../api/speak-doctor';
import AuthGuestLoggedin from '../../../services/AuthGuestLoggedinService';

const authCheck = new AuthGuestLoggedin()

/**
 * 0 emergencySymptoms
 * 1 age
 * 2 howManyPeopleDoYouLiveWith
 * 3 doYouOrAnyoneYouLiveWorkHealthcareFacility
 * 4 symptoms
 * 5 additionalSymptoms
 * 6 isExposedFeverOrCoughPast14Days
 * 7 hadAFeverInTheLast14Days
 * 8 hadAContinuousCoughInTheLast14Days
 * 9 hadALossInTasteAndSmellInTheLast14Days
 * 10 beenDiagnosedWithConditions
 * 11 haveTheFollowing
 * 12 isApplyToYou
 */

const CovidWrapper = ({ title, prevRoutePath, isFirst, isLastQuestion, children, ...restNavBtnProps }) => (
  <>
    <Box textAlign="center" fontWeight={500} color="#15A9E1">
      {title}
    </Box>
    {children}
    <PregnantNavBtn isFirst={isFirst} prevRoutePath={prevRoutePath} isLast={isLastQuestion} {...restNavBtnProps} />
  </>
);

function MobileCovidScreen() {
  const { t } = useTranslation(['common', 'speak-doctor']);
  const match = useRouteMatch();
  const history = useHistory();
  const { path } = match;

  const initialValues = {
    "1_answeringQuestionForYourself": '',
    "2_age": 30,
    "3_gender": '',
    "4_howManyPeopleDoYouLiveWith": '',
    "5_doYouOrAnyoneYouLiveWorkHealthcareFacility": '',
    "6_doYouHaveAnySymptoms": [],
    "7_doYouHaveAnySymptoms": [],
    "8_exposedToSomeoneWithFever": '',
    "9a_hadFeverStatus": null,
    "9a_hadFeverDays": 0,
    "9b_tasteSmellStatus": null,
    "9b_tasteSmellDays": 0,
    "10_continuousCoughStatus": null,
    "10_continuousCoughDays": 0,
    "11_diagnosedWith": [],
    "12_any": [],
    "13_applyToYou": []
  };

  const renderRoutes = (routes, total = routes.length, gender) =>
    routes.map(({ id: count, path: p, component: Component, props: componentProps }) => {
      const {
        prevRoutePath,
        nextRoutePath,
        additionalRoute,
        recommendedRoute,
        options,
        isMultiSelect,
        ...restComponentProps
      } = componentProps;

      let updatedOptions = options;

      if (componentProps.fieldName === 'isApplyToYou' && gender === 'male') {
        updatedOptions = [...options];
        updatedOptions.shift();
      }

      // if(employeeStatus.covid_screening_done){
      //   return <Redirect to={{ pathname: '/welcome/status' }} />
      // }

      return (
        <Route key={p} path={p}>
          <CovidWrapper
            title={
              count > 0
                ? t('questions:questionsCount', { count, total: total + 1 })
                : t('questions:emergencySymptoms.title')
            }
            fieldName={componentProps.fieldName}
            isLastQuestion={componentProps.isLastQuestion}
            prevRoutePath={prevRoutePath}
            nextRoutePath={nextRoutePath}
            additionalRoute={additionalRoute}
            recommendedRoute={recommendedRoute}
          >
            <Component
              options={updatedOptions}
              isMultiSelect={isMultiSelect}
              {...restComponentProps}
            />
          </CovidWrapper>
        </Route>
      );
    });
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={async (values, { setSubmitting, resetForm }) => {

          const answers = { ...values };
          const tempHadFever = {
            status: answers["9a_hadFeverStatus"],
            number_of_days: answers["9a_hadFeverDays"]
          }

          const tempTasteSmellStatus = {
            status: answers["9b_tasteSmellStatus"],
            number_of_days: answers["9b_tasteSmellDays"]
          }

          const tempContinuousCoughStatus = {
            status: answers["10_continuousCoughStatus"],
            number_of_days: answers["10_continuousCoughDays"]
          }

          if (tempHadFever.status !== true) {
            tempHadFever.number_of_days = 0;
          }
          if (tempTasteSmellStatus.status !== true) {
            tempTasteSmellStatus.number_of_days = 0;
          }
          if (tempContinuousCoughStatus.status !== true) {
            tempContinuousCoughStatus.number_of_days = 0;
          }

          answers["9a_hadFever"] = tempHadFever
          answers["9b_tasteSmell"] = tempTasteSmellStatus
          answers["10_continuousCough"] = tempContinuousCoughStatus

          try {
            const { responseOk, responseJSON } = await postScreeningAPICall({
              covidQuestionnaires: answers
            });
            setSubmitting(false);
            resetForm({ values: initialValues });
            if (!responseOk) {
              throw new Error(`${responseOk} - ${responseJSON}`);
            }
            authCheck.redirectSpeakDoctor()
          } catch (err) {
            console.error(err);
            errorNotification(t('common:form.error.submit'));
            setSubmitting(false);
            resetForm({ values: initialValues });
            history.push(`/speak-doctor/covid/question-for`);
          }
        }}
      >
        {({ isSubmitting, values }) => (
          <Form loading={isSubmitting.toString()}>
            {isSubmitting}
            <Box paddingTop={20} paddingBottom={36} paddingX={20}>
              <Switch>
                {renderRoutes(
                  getMobileCovidRoutes(),
                  getMobileCovidRoutes().length - 1,
                  values.gender
                )}
                {renderRoutes(
                  getMobileCovidFromYesAnswerRoutes(),
                  getMobileCovidRoutes().length - 1
                )}
                {/* <Redirect to={`${path}/emergency-symptoms`} /> */}
                <Redirect to={`${path}/question-for`} />
              </Switch>
            </Box>
            {!isSubmitting && <Persist name="covid-screening-form" />}
            {isSubmitting ? (
              <LoadingSpinner position="full" transparent={false} />
            ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
}

export default MobileCovidScreen;
